<template>
  <div
    class="is-flex is-flex-direction-row is-flex-wrap-nowrap seatmap-row"
    :class="{ 'is-overwing': isOverwingRow, 'is-exitrow': isExitRow }"
  >
    <!--<div class="column is-narrow" style="width:150px">
            <span class="has-text-grey">
                <h5 class="is-size-6">{{ rowNumberLabel }}</h5>
                <span class="is-size-7">{{ seatCount }} seats</span>
            </span>
        </div>-->

    <!--<div class="column is-narrow overwing-container" v-if="isOverwingRow"></div>
        <div class="column is-narrow not-overwing-container" v-else></div>-->
    <!-- {{mapColumns[3]}} -->

    <RowElement
      v-for="(seat, seatId) in columns"
      :key="seatId"
      :seat="seat"
      :orientation="orientation"
      @selected="selectSeat"
      :isExitRow="isExitRow"
      class="seatmap-column"
    />

    <!--<div v-for="seat in mapColumns" :key="seat.id" class="column is-narrow seatmap-column" >

            <Seat :seat="seat" v-if="seat.id != 'aisle'"></Seat>

            <Gap v-if="seat.id == 'gap'"></Gap>

            <Aisle v-if="seat.id == 'aisle'"></Aisle>

        </div>-->
  </div>
</template>

<script>
//import Seat from './Seat.vue'
//import Aisle from './Aisle.vue'
//import Gap from './Gap.vue'
import RowElement from "./RowElement.vue";

export default {
  components: {
    //Seat,
    //Aisle,
    //Gap,
    RowElement,
  },
  props: {
    seats: Array,
    rowNumber: Number,
    aisleLeftColumn: String,
    aisleRightColumn: String,
    overwingRows: Array,
    orientation: String,
    //mapColumns: Number,
  },
  data() {
    return {
      columns: [],
    };
  },
  computed: {
    rowNumberLabel() {
      return "Row " + this.rowNumber;
    },
    seatCount() {
      return this.seats.length;
    },
    isOverwingRow() {
      return this.overwingRows.includes(parseInt(this.rowNumber));
    },
    isExitRow() {
      let matched = this.seats[0].characteristics.find((char) => {
        return char.code == "E"; // no seat at this location
      });

      return matched;
    },
  },
  methods: {
    selectSeat(value) {
      this.$emit("selected", value);
    },
    mapColumns() {
         let mapColumns = []

         let aisle = {
             id: 'aisle'
         }

         let gap = {
             id: 'gap'
         }

         let seatColumnsOrder = [
             'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'
         ]

         // let nextSeatColumn = 'A'

         // // console.log(this.rowNumber)

         this.seats.forEach((seat) => {

            // // console.log(seatColumnsOrder)

            // Set the expected column name
            let expectedColumn = seatColumnsOrder.shift()

            // // console.log(expectedColumn)
            // // console.log(seat.column.name)

            // If the next expected seat is not the same as the
            // seat column, put in a gap
            //if (expectedColumn != seat.column.name) {
            while (expectedColumn != seat.column.name) {
              if (expectedColumn == this.aisleRightColumn) {
                  mapColumns.push(aisle)
              }
                // mapColumns.push(gap)
              if (expectedColumn == this.aisleLeftColumn) {
                  mapColumns.push(aisle)
              }
                expectedColumn = seatColumnsOrder.shift()
            }

            // If the seat column is identified as being the
            // column on the right side of the aisle put an aisle
            // to the left of it
            if (this.aisleRightColumn == seat.column.name) {
                mapColumns.push(aisle)
            }

            // Put the seat in the column
            if (expectedColumn == seat.column.name) {
                mapColumns.push(seat)
            }

            // If the seat column is identified as being the
            // column on the left side of the aisle put an aisle
            // to the right of it
            if (this.aisleLeftColumn == seat.column.name) {
                mapColumns.push(aisle)
            }
         })

         return mapColumns
      },

  },
  mounted() {
    this.columns = this.mapColumns();
  }

};
</script>

<style scoped>
.seatmap-row {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  border-left: 10px solid #ddd;
  border-right: 10px solid #ddd;
}

.is-overwing {
  border-left: 10px solid #ccc;
  border-right: 10px solid #ccc;
}

.is-exitrow {
  background: aliceblue;
  border-left: 10px solid #ddd;
  border-right: 10px solid #ddd;
}

.seatmap-column {
  position: relative;
  padding: 0;
}
</style>
